<section id="articleBackground" [ngStyle]="{'background-image': 'linear-gradient(rgba(0,0,0,0.82), rgba(0,102,153,0.9)), url('+article.posterUrl+')', 'background-size': 'cover', 'background-position': 'center'}">
  <div class="half-black">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="display-4" >{{article.title ? article.title : (articleLoaded ? 'Undergoing Maintenance' : '')}}</h1>
          <div class="text-white"><time itemprop="datePublished" datetime pubdate>{{article.date | date: "MMM d, yyyy"}}</time></div>
          <div class="text-white">{{article.views ? 'Views: ' + article.views : ''}} </div>
        </div>

      </div>

    </div>
  </div>
</section>

<section id="mainArticle">
  <main role="main" class="container">
    <div class="row">
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item"><a routerLink="/">Home</a></li>
          <li class="breadcrumb-item"><a routerLink="/articles">Articles</a></li>
          <li class="breadcrumb-item active" aria-current="page">{{article.title}}</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-lg-8 col-md-12 blog-main ">
        

        <div class="blog-post">
          @if (articleLoaded) {
            <div>
              <div [innerHTML]="(article.content ? article.content : 'This article is currently undergoing maintenance and is unavailable at this time. Please check back later. Sorry for the inconvenience.') | safe:'html'"></div>
            </div>
          }
        </div><!-- /.blog-post -->



        <!--About the Author -->
        @if (authors && authors.length > 0){
          <div class="about-author " name="abouttheauthor">
            <h2 id="author" class="articleH2 pt-3 ">About the Author</h2>
            <div id="aboutAuthor" class="py-3 ">
              <img width="75" height="auto" class="float-start me-3 mb-3 " alt="{{article.author}}" src="{{authors[0].imageUrl}}">
              <p class="">{{article.author}}<span class=""> - <span>{{authors[0].description}}</span></span></p>
              <p class="">
                {{authors[0].about}}
              </p>
            </div>
          </div>
        }
      </div><!-- /.blog-main -->

      <div class="col-lg-4 col-md-12 blog-sidebar ">
        <img class="card-img-right flex-auto d-md-block img-fluid" src="{{article.posterUrl}}" width="350"
          alt="">
          <div class="p-3 mb-3 bg-light rounded flex-row">
            <div>
              @if(authors && authors.length > 0) {
              <img width="85" height="auto" class="float-start me-3 mb-3 " alt="{{article.author}}" src="{{authors[0].imageUrl}}">
              }
            </div>
            <div>
              <h4>Written By</h4>
              <p class="mb-0"><a routerLink="." fragment="abouttheauthor">{{article.author ? article.author : ''}} </a></p>
            </div>
          </div>

          

          <div class="p-3 social-icons">
            <h4>Share</h4>
            <ul class="">
              <li (click)="socialsharefacebook()" class="social-share facebook"><i><app-facebook></app-facebook></i></li>
              <li (click)="socialsharetwitter()" class="social-share twitter"><i><app-twitter></app-twitter></i></li>
              <li (click)="socialsharelinkedin()" class="social-share linkedin"><i><app-linkedin></app-linkedin></i></li>
              <li (click)="emailCurrentPage()" class="social-share email"><i class="fa fa-envelope"><fa-icon [icon]="faEnvelope" size="1x"></fa-icon></i></li>
            </ul>
          </div>

          <div class="p-3">
            <h4>Other Articles</h4>
            <ol class="list-unstyled mb-0">
              @for (article of articles; track article; let x = $index) {
                <li>
                  @if (x < 3) {
                    <a routerLink="/articles/{{article.friendlyUrl}}">{{article.title}}</a>
                      <!-- <app-similar-articles [data]="article"></app-similar-articles> -->
                   
                  }
                </li>
              }
            </ol>
          </div>



          <div>

            <img alt="Download Investing for Catholics Brochure" src="https://services.ifa.com/art/images/3646_255x330_c_ifc-brochure-2026_q80.webp" class="mb-5" style="max-width:100%; height:auto; aspect-ratio: 255/330;" width="255" height="330">
            <div class="clearfix"></div>
            <a href="https://www.ifa.com/pdfs/ifc_brochure.pdf" target="_blank" class="btn btn-primary">Download Brochure</a>    



          </div>



        </div><!-- /.blog-sidebar -->

      </div><!-- /.row -->

    </main>
  </section>

